"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaFeature = void 0;
const TopAreaFeature = exports.TopAreaFeature = {
  /** Enables notification icon in the Top Navigation 3.0 */
  DisplayNotificationIcon: '49AA31AA-2B5A-44E0-AF09-C19FFAE41647',
  /** Enables benefit banner in top area */
  EnableTopAreaBanner: '7FB3B359-570F-407A-80B1-105AACBB6268',
  /** Enables third party script */
  EnableABTasty: 'B4A1E51C-3D6A-4867-9CEC-E938E76C081B',
  /** Display only products tab in search */
  OnlyProductsTabInSearch: '29DD036C-49BA-422E-8DDB-8C58317DD34B',
  /** Enable new favourite-lists landing page replacing favourite-products page", docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11819/Favourite-lists */
  FavouriteLists: '7BBF1CAE-7EEC-440D-AA50-C0953B761DA9',
  /** Enable personal subscriptions, docs: https://dev.azure.com/oriflame/GlobalDev/_wiki/wikis/GlobalDev.wiki/11422/Personal-subscriptions */
  PersonalSubscriptions: '7D673EF4-D085-44B5-BB1C-8FE57F1286BD',
  /** Use new top area navigation */
  UseTopAreaNavigationMenu: '4E74A3FB-9CED-418A-A73D-D22C0206CAD4',
  /** "When enabled, the permanent minibag will be removed from the catalogue."; */
  RemovePermanentMiniBagFromCatalogue: 'B97055D2-F4B9-41B0-B18C-B867983AE043'
};
